import { LandingStepErrorsEnum } from "../enums";
import { ILandingActiveStepError } from "../models";

export const createActiveStepError = <T>(
  errorType: LandingStepErrorsEnum,
  data?: T,
): ILandingActiveStepError => {
  return {
    type: errorType,
    data,
  };
};
